import type { AccountRelatedListKey } from '~/services/ContractingService';

export const accountQueryKeys = {
  all: ['contracting', 'account'] as const,
  bySalesforceId: (salesforceAccountId: string) =>
    [...accountQueryKeys.all, 'by-salesforce-id', salesforceAccountId] as const,
  details: (accountId: string) => [...accountQueryKeys.all, accountId, 'details'] as const,
  related: (accountId: string) => [...accountQueryKeys.all, accountId, 'related'] as const,
  relatedList: (accountId: string, list: AccountRelatedListKey) =>
    [...accountQueryKeys.related(accountId), list] as const,
};
